import { render, staticRenderFns } from "./SitchOrderItemBreakdown.vue?vue&type=template&id=48530012&scoped=true&"
import script from "./SitchOrderItemBreakdown.vue?vue&type=script&lang=ts&"
export * from "./SitchOrderItemBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./SitchOrderItemBreakdown.vue?vue&type=style&index=0&id=48530012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48530012",
  null
  
)

export default component.exports